module.exports = __webpack_public_path__ + "img/208F.dd87b82e.jpg";